import { render, staticRenderFns } from "./cashpledge.vue?vue&type=template&id=55f217b2&scoped=true"
import script from "./cashpledge.vue?vue&type=script&lang=js"
export * from "./cashpledge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f217b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55f217b2')) {
      api.createRecord('55f217b2', component.options)
    } else {
      api.reload('55f217b2', component.options)
    }
    module.hot.accept("./cashpledge.vue?vue&type=template&id=55f217b2&scoped=true", function () {
      api.rerender('55f217b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/withdraw/cashpledge.vue"
export default component.exports